<template lang="pug">
#vib-footer-container(:class="{ simple: simplified }")
  template
    .vib-member-container.desktop
      .vib-content
        .title-row
          FontShadow(textContent="VIB <br class='mobile'>MEMBER", top="0", left="-60px", textAlign="left", color="white", shadowColor="rgba(196, 196, 196, 0.2)")
          .image-container.mobile
            img(v-lazy="require('../assets/images/characters/vib.png')")
        p Experience the VIP treatment - sign up and start enjoying the benefits of your LEGO&reg; VIB.
        router-link(to="/vib-membership").yellow-button Read More
      .vib-image-container.desktop
        img(v-lazy="require('../assets/images/characters/vib.png')")

    .vib-newsletter-container.desktop
      FontShadow(textContent="NEWSLETTER", top="0", left="-60px", textAlign="left", color="#212121", shadowColor="rgba(255, 255, 255, 0.4)")
      p Subscribe to LEGO&reg; Malaysia updates!
      form.form-field(@submit.prevent="subscribeNewsletter")
        input(type="email", placeholder="Email address...", v-model="newsletterForm")
        input.blue-button(type="submit", value="Subscribe")

  template(v-if="!simplified")
    .vib-member-container.mobile(v-if="!simplified")
      .vib-content
        .title-row
          FontShadow(textContent="VIB <br class='mobile'>MEMBER", top="0", left="-60px", textAlign="left", color="white", shadowColor="rgba(196, 196, 196, 0.2)")
          .image-container.mobile
            img(v-lazy="require('../assets/images/characters/vib.png')")
        p Experience the VIP treatment - sign up and start enjoying the benefits of your LEGO&reg; VIB.
        router-link(to="/vib-membership").yellow-button Read More
      .vib-image-container.desktop
        img(v-lazy="require('../assets/images/characters/vib.png')")

    .vib-newsletter-container.mobile
      FontShadow(textContent="NEWSLETTER", top="0", left="-60px", textAlign="left", color="#212121", shadowColor="rgba(255, 255, 255, 0.4)")
      p Subscribe to LEGO&reg; Malaysia updates!
      form.form-field(@submit.prevent="subscribeNewsletter")
        input(type="email", placeholder="Email address...", v-model="newsletterForm")
        input.blue-button(type="submit", value="Subscribe")

  template(v-if="simplified")
    .vib-simple.mobile
      router-link.vib-member(to="/vib-membership")
          span BECOME A VIB MEMBER
      .vib-newsletter(@click="showNewsletterModal")
        span NEWSLETTER
</template>

<script>
import FontShadow from './font-shadow.vue'
import axios from 'axios'

export default {
  props: ['simplified'],
  components: {
    FontShadow
  },

  data () {
    return {
      newsletterForm: ''
    }
  },

  methods: {
    showNewsletterModal () {
      this.$store.commit('activateModal', {
        modalName: 'newsletter'
      })
    },

    async subscribeNewsletter () {
      try {
        this.$store.commit('setLoadingState', true)

        await axios.post('/api/user/newsletter', {
          email: this.newsletterForm
        })

        this.$store.commit('setLoadingState', false)

        this.$store.commit('activateModal', {
          modalName: 'message',
          textContent: 'Thank you for subscribing to our Newsletter.',
          characterImageOne: 'notify-body',
          characterImageTwo: 'notify-hand',
          ctaText: 'Got It',
          ctaAction: () => {
            this.$store.commit('closeModal', { modalName: 'message' })
          }
        })
      } catch (err) {
        console.log(err.response.data)
        this.$store.commit('setLoadingState', false)
      }
    }
  }
}
</script>

<style lang="sass">
@import '../sass/_variables.sass'

#vib-footer-container
  padding-left: 0px
  padding-top: 120px
  box-sizing: border-box
  position: relative
  padding-bottom: 120px
  overflow: hidden
  background-color: white
  @media screen and (min-width: 640px) and (max-width: 850px)
    padding-bottom: 60px
  +mobile
    padding-left: 0
    padding-top: 100px
    padding-bottom: 40px
  &.simple
    +mobile
      padding-bottom: 0
  .vib-member-container
    color: white
    background-color: $blue
    display: inline-flex
    align-items: center
    padding: 20px 60px 20px 20px
    box-sizing: border-box
    width: 65%
    position: relative
    z-index: 2
    @media screen and (min-width: 640px) and (max-width: 850px)
      width: calc(100% - 20px)
    +mobile
      width: 95%
    &:before
      content: ""
      position: absolute
      height: 100%
      width: 16px
      right: -16px
      background-image: url('../assets/images/teeth/teeth-right-blue.png')
      background-size: 100%
      transform: translateX(-1px)

    .vib-content
      padding-right: 20px
      padding-left: 60px
      +mobile
        padding: 0
      .title-row
        +mobile
          display: flex
          align-items: flex-end
        h2
          font-style: italic
          font-weight: 900
          font-size: 50px
          margin-bottom: 4px
          +mobile
            font-size: 1.8em
        .image-container
          img
            +mobile
              width: 100%
              transform: translate(35px, 20px)
      p
        font-size: 18px
        line-height: 26px
        margin-top: 0px
        +mobile
          font-size: 16px
          line-height: 22px
      .yellow-button
        margin-top: 30px
        display: inline-block
        +mobile
          width: 100%
    .vib-image-container
      img
        width: 100%

  .vib-newsletter-container
    background-color: $yellow
    color: #212121
    width: 37%
    position: absolute
    padding: 60px 60px 40px 100px
    box-sizing: border-box
    top: 31%
    right: 0
    z-index: 1
    @media screen and (min-width: 640px) and (max-width: 850px)
      position: relative
      width: calc(100% - 45px)
      margin-left: 60px
      top: 0
      padding: 40px 60px
    +mobile
      margin-left: 40px
      width: calc(100% - 40px) // 40px = margin-left
      position: relative
      padding: 38px 17px 31px 19px
      top: 0
    &:after
      content: ''
      position: absolute
      height: 1000px
      width: 100%
      top: 100%
      left: 0
      background-color: $light-yellow
      transform-origin: left top
      transform: rotate(-50deg)
      z-index: -1
    &:before
      +desktop
        content: ""
        position: absolute
        height: 100%
        width: 100%
        background-color: white
        top: -100%
    .font-shadow
      .shadow
        z-index: -1
    h2
      font-style: italic
      font-weight: 900
      font-size: 50px
      margin-bottom: 4px
      +mobile
        font-size: 40px
    p
      font-size: 18px
      line-height: 26px
      margin-top: px
      +mobile
        font-size: 16px
        line-height: 22px

    .form-field
      margin-top: 32px
      +mobile
        margin-top: 16px
      input
        padding: 10px
        width: 100%
        font-size: 14px
        box-sizing: border-box
        &::placeholder
          color: #C4C4C4
        &.blue-button
          font-size: 18px !important
          padding: 15px 30px
      .blue-button
        display: block
        width: 100%
        margin-top: 10px

  .vib-simple
    display: flex
    text-align: center
    height: 82px
    .vib-member
      display: flex
      align-items: center
      background-color: $blue
      flex: 1
      font-size: 20px
      line-height: 22px
      color: white
      font-weight: 900
      width: 100%
      font-style: italic
      box-sizing: border-box
      span
        padding: 0 20px
    .vib-newsletter
      background-color: $yellow
      display: flex
      align-items: center
      flex: 1
      color: black
      font-size: 20px
      font-weight: 900
      font-style: italic
      cursor: pointer
      span
        width: 100%
</style>
